module.exports = __webpack_public_path__ + "img/symbol_0.cb48f6a2.png";